/**
 * Shared PA status bucket Select options for the Text Notes and Letter Upload
 * "Add New Status" modals.
 */
import { PA_STATUS_BUCKET_OPTIONS } from "../../../../../constants/oncologySubmission";
import { PaStatusBucket } from "../../../../../enums/paStatusBucket";

/**
 * Builds Select options for PA status buckets not already configured in the table.
 *
 * @param usedBuckets - Bucket ids already present in the Eligible PA Statuses table
 * @returns Select options with bucket id as value and human label as label
 */
export function buildAvailableBucketOptions(usedBuckets: string[]) {
  const used = new Set(usedBuckets);
  return PA_STATUS_BUCKET_OPTIONS.filter(
    (option) =>
      option.id !== PaStatusBucket.NO_PREDEFINED_BUCKETS &&
      !used.has(option.id),
  ).map((option) => ({ value: option.id, label: option.text }));
}
